<template>
  <div>
    <div :class="bgFlag?'tarnsf':''">
      <div class="iheader"
           :class="moveFlag?'bgColor':''">
        <h1 class="ihed_h1">
          <img src="~@/assets/images/svg/logo_top_black.svg"
               class="logo_pic"
               @click="toHome()"
               v-show="!bgFlag" />
          <img src="~@/assets/images/svg/logo_top_white.svg"
               class="logo_pic"
               @click="toHome()"
               v-show="bgFlag" />
        </h1>
        <div class="herg">
          <span class="herg_lang"
                @click='changeLang()'>{{lang}}</span>
          <i class="herg_mu"
             @click="nuneClick(1)"></i>
        </div>
      </div>
    </div>
    <div class="hdplace"></div>
    <div class="imageList">
      <div class="bread">
        <div class="bread_lf">
          <span class="bread_nu">酒店设计</span>
          <i class="sel_ico"></i>
        </div>
        <div class="bread_rg">
          <i class="rgmu"></i>
        </div>
      </div>
      <div class="jdCon">
        <div class="jdCon_tp clearfix">
          <div class="jdCon_lf">
            <p class="jdCon_tp_na">酒店设计</p>
          </div>
          <div class="jdCon_rg">
            <p class="jdCon_rg_p">依托理想国西川4公里沿河景致的生态资源，紧邻西川的西5苑下叠户型为住宅空间打造提供了丰富的自然环境。整个项目设计意在放大空间尺度，公共区域采用“去中心化”的设计手法，让各个功能区有机串联，启发“无边界”的生活方式。</p>
          </div>
        </div>
        <div class="wzCon_bd clearfix">
          <div class="wzList_li">
            <p class="wzList_li_p1">江山万里云酒店</p>
            <p class="wzList_li_p2">宁波 中国, 2018</p>
          </div>
          <div class="wzList_li">
            <p class="wzList_li_p1">鼎赞酒店</p>
            <p class="wzList_li_p2">宁波 中国, 2018</p>
          </div>
          <div class="wzList_li">
            <p class="wzList_li_p1">七仙岭君澜度假酒店 雨林西餐厅 </p>
            <p class="wzList_li_p2">宁波 中国, 2018</p>
          </div>
          <div class="wzList_li">
            <p class="wzList_li_p1">江山万里云酒店</p>
            <p class="wzList_li_p2">宁波 中国, 2018</p>
          </div>
          <div class="wzList_li">
            <p class="wzList_li_p1">香⽔湾君澜度假酒店 茶书吧</p>
            <p class="wzList_li_p2">宁波 中国, 2018</p>
          </div>
          <div class="wzList_li">
            <p class="wzList_li_p1">三亚丽禾温德姆酒店</p>
            <p class="wzList_li_p2">宁波 中国, 2018</p>
          </div>
          <div class="wzList_li">
            <p class="wzList_li_p1">鼎赞酒店</p>
            <p class="wzList_li_p2">宁波 中国, 2018</p>
          </div>
          <div class="wzList_li">
            <p class="wzList_li_p1">江山万里云酒店</p>
            <p class="wzList_li_p2">宁波 中国, 2018</p>
          </div>
          <div class="wzList_li">
            <p class="wzList_li_p1">三亚丽禾温德姆酒店</p>
            <p class="wzList_li_p2">宁波 中国, 2018</p>
          </div>
          <div class="wzList_li">
            <p class="wzList_li_p1">江山万里云酒店</p>
            <p class="wzList_li_p2">宁波 中国, 2018</p>
          </div>
        </div>
        <div class="listMore">
          <i class="more_ico"></i>
        </div>
      </div>
      <!-- footer -->
      <foot @contact="contact"></foot>
      <transition name="slide-fade">
        <munePage v-show="muneFlag"
                  :muneFlag="muneFlag"
                  :muneIndex="muneIndex"
                  @closeMu="closeMu"
                  @muneChange='muneIndexChange'></munePage>
      </transition>
    </div>
  </div>
</template>

<script>
import { WOW } from 'wowjs'
import foot from '@/components/foot.vue'
import gotop from '@/components/goTop.vue'
import munePage from '@/pages/munePage.vue'
import { mapMutations, mapGetters, mapState } from 'vuex'

export default {
  data() {
    return {
      bgFlag: false,
      muneFlag: false,
      muneIndex: -1,
      mySwiper: null,
      moveFlag: false,
    }
  },
  components: { foot, gotop, munePage },
  mounted() {
    this.$nextTick(() => {
      // 在dom渲染完后,再执行动画
      var wow = new WOW({
        live: false,
      })
      wow.init()
    })
    // 滚动条滚动
    window.addEventListener('scroll', this.handleScroll)
  },
  computed: {
    ...mapState(['langFlag', 'lang']),
  },
  methods: {
    // 菜单
    nuneClick(index) {
      this.muneFlag = true
      this.muneIndex = 1
    },
    closeMu() {
      this.muneFlag = false
    },
    contact() {
      this.muneFlag = true
      this.muneIndex = 3
    },
    muneIndexChange(index) {
      this.muneIndex = index
    },
    handleScroll() {
      // 页面滚动距顶部距离
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
      var winH =
        document.documentElement.clientHeight || document.body.clientHeight
      var scroll = scrollTop - this.i
      this.i = scrollTop
      if (scroll <= 0) {
        this.moveFlag = false
      } else {
        this.moveFlag = true
      }
      if (scrollTop < winH) {
        this.bgFlag = false
      } else {
        this.bgFlag = true
      }

      // let t1 = document.documentElement.scrollTop || document.body.scrollTop
      // if (t1 > 10) {
      //   this.moveFlag = true
      // } else {
      //   this.moveFlag = false
      // }
    },
    //切换语言
    changeLang() {
      // this.SET_WFFLAG(true)
      console.log('语言1', this.langFlag)
      this.$store.commit('setLang', !this.langFlag)
      this.$store.commit('setLa', this.lang == 'EN' ? 'CH' : 'EN')
      console.log('语言', this.langFlag)
    },
    // 返回首页
    toHome() {
      this.$router.push({
        name: 'home',
        // query: {
        //   type: type,
        // },
      })
    },
  },
}
</script>






// WEBPACK FOOTER //
// src/pages/wzList.vue